import * as React from 'react';
import { connect } from 'react-redux';

import { hotTable } from 'shared/helpers';
import { Button } from 'shared/view/elements';
import withCheckAccessAction from 'services/AccessActionModal/withCheckAction';

import { actionCreators } from '../../../redux';
import { DownloadMediaplan } from '../../../types';
import { autobind } from 'core-decorators';

type OwnProps = {
  disabled: boolean;
} & DownloadMediaplan['payload'];

type ActionProps = typeof containerActionCreators;

type Props = OwnProps & ActionProps;

class DownloadMediaplanButton extends React.PureComponent<Props> {
  private DownloadButton = withCheckAccessAction({
    WrappedComponent: Button,
    checkedAction: 'onClick',
    accessButtonText: 'Продолжить',
    cancelButtonText: 'Отмена',
    getTitle: () => 'Будут экспортированы только отфильтрованные строки. Для экспорта всех строк, пожалуйста, сбросьте фильтры вручную или обновив страницу',
    conditionShowWarning: () => {
      const ht = this.props.getHotInstance();
      if (!ht) {
        return false;
      }
      const filters = hotTable.getFilters(ht);
      return !!filters.length;
    },
  });
  
  public render() {
    return (
      <this.DownloadButton
        disabled={this.props.disabled}
        onClick={this.handleMediaplanDownload}
      >
        Скачать
      </this.DownloadButton>
    );
  }

  @autobind
  private handleMediaplanDownload() {
    const { columnRangeHeaders, getHotInstance, validate, downloadMediaplan } = this.props;
    downloadMediaplan({ columnRangeHeaders, getHotInstance, validate });
  }
}

const containerActionCreators = {
  downloadMediaplan: actionCreators.downloadMediaplan,
};

export default connect(null, containerActionCreators)(DownloadMediaplanButton);
